import { getNormalizedHosts, getParentDomain, normalizeHostname } from '@/utils/runtime-hostnames';

type RuntimeUiConfig = {
  AUTH_UI_ALIASES?: string[];
  AUTH_UI_URL?: string;
  COOKIE_DOMAIN?: string;
  HITL_UI_ALIASES?: string[];
  HITL_UI_URL?: string;
  SDK_API_ALIASES?: string[];
  SDK_API_URL?: string;
};

const getAliasHostSet = (aliases: string[]) => new Set(aliases);

const getAliasesByParentDomain = (aliases: unknown) => {
  const aliasesByParentDomain = new Map<string, string>();

  getNormalizedHosts(aliases).forEach(alias => {
    const parentDomain = getParentDomain(alias);

    if (parentDomain) {
      aliasesByParentDomain.set(parentDomain, alias);
    }
  });

  return aliasesByParentDomain;
};

export const resolveRuntimeUiConfig = (
  config: RuntimeUiConfig,
  location = typeof window !== 'undefined' ? window.location : undefined,
) => {
  const currentHostname = location ? normalizeHostname(location.hostname) : '';
  const hitlAliases = getNormalizedHosts(config.HITL_UI_ALIASES);
  const authAliases = getNormalizedHosts(config.AUTH_UI_ALIASES);
  const sdkApiAliasesByParentDomain = getAliasesByParentDomain(config.SDK_API_ALIASES);
  const aliasModeEnabled = Boolean(currentHostname) && getAliasHostSet(hitlAliases).has(currentHostname);
  const currentParentDomain = aliasModeEnabled ? getParentDomain(currentHostname) : '';
  const authAlias = currentParentDomain
    ? authAliases.find(alias => getParentDomain(alias) === currentParentDomain)
    : '';
  const sdkApiAlias = currentParentDomain
    ? sdkApiAliasesByParentDomain.get(currentParentDomain)
    : '';

  return {
    AUTH_UI_ALIASES: authAliases,
    AUTH_UI_URL: authAlias && location ? `${location.protocol}//${authAlias}` : config.AUTH_UI_URL || '',
    COOKIE_DOMAIN: aliasModeEnabled
      ? getParentDomain(currentHostname) || config.COOKIE_DOMAIN || ''
      : config.COOKIE_DOMAIN || '',
    HITL_UI_ALIASES: hitlAliases,
    HITL_UI_URL: aliasModeEnabled && location ? location.origin : config.HITL_UI_URL || '',
    SDK_API_ALIASES: getNormalizedHosts(config.SDK_API_ALIASES),
    SDK_API_URL: sdkApiAlias && location ? `${location.protocol}//${sdkApiAlias}` : config.SDK_API_URL || '',
    aliasModeEnabled,
    currentHostname,
    currentParentDomain,
  };
};
